import moment from 'moment';
let startDt = moment().startOf('month').format('YYYY-MM-DD');
let endDt = moment().endOf('month').format('YYYY-MM-DD');

export default {
	partClList: [], //유형(초도품, 초기양산, 양산, 변경품) selectBox
	ovrlJgmtList: [], //종합판정(합격/불합격/결품) selectBox
	pgsStPcList: [], //검사상태(검사중/검사완료/반려/작성/승인) selectBox
	useYnList: [],
	lotNoList: [],
	resultList: [],
	partCkuScrId: '', // 부품검사 화면 ID(품명 클릭시 부품검사 화면으로 이동하기 위해 필요함)
	searchParams: SEARCH_PARAMS(),
	pagingInfo: PAGING_INFO()
};

function SEARCH_PARAMS() {
	return {
		partNo: '',
		partNm: '',
		ckuNo: '',
		cofCd: '',
		cofNm: '',
		strDt: startDt,
		endDt: endDt,
		lastYn: 'N',
		pgsStCd: '', //검사상태
		orderNo:''
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}
export { SEARCH_PARAMS, PAGING_INFO };
